import React from 'react';
import { useTranslation } from 'react-i18next';

const SendRequestForm = ({
  searchUsername,
  setSearchUsername,
  selectedRoles,
  setSelectedRoles,
  onSubmit,
  isLoading
}) => {
  const { t } = useTranslation();

  // Backend expects these specific roles
  const availableRoles = [
    { value: 'full', label: t('player.parents.roles.fullAccess'), description: t('player.parents.roles.fullAccessDesc') },
    { value: 'feed', label: t('player.parents.roles.feedAccess'), description: t('player.parents.roles.feedAccessDesc') },
    { value: 'event', label: t('player.parents.roles.eventAccess'), description: t('player.parents.roles.eventAccessDesc') },
    { value: 'performance', label: t('player.parents.roles.performanceAccess'), description: t('player.parents.roles.performanceAccessDesc') },
    { value: 'payment', label: t('player.parents.roles.paymentAccess'), description: t('player.parents.roles.paymentAccessDesc') }
  ];

  return (
    <div className="mb-8 bg-blue-50 rounded-lg p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{t('player.parents.sendParentRequest')}</h3>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('player.parents.parentUsername')}
          </label>
          <input
            type="text"
            value={searchUsername}
            onChange={(e) => setSearchUsername(e.target.value)}
            placeholder={t('player.parents.enterParentUsername')}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t('player.parents.accessPermissions')}
          </label>
          <div className="space-y-3">
            {availableRoles.map((role) => (
              <label key={role.value} className="flex items-start">
                <input
                  type="checkbox"
                  checked={selectedRoles.includes(role.value)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedRoles([...selectedRoles, role.value]);
                    } else {
                      setSelectedRoles(selectedRoles.filter(r => r !== role.value));
                    }
                  }}
                  className="mt-1 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
                <div className="ml-3">
                  <span className="text-sm font-medium text-gray-700">{role.label}</span>
                  <p className="text-xs text-gray-500">{role.description}</p>
                </div>
              </label>
            ))}
          </div>
        </div>

        <button
          type="submit"
          disabled={!searchUsername.trim() || selectedRoles.length === 0 || isLoading}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
        >
          {isLoading ? (
            <div className="flex items-center gap-2">
              <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
              {t('player.parents.sending')}
            </div>
          ) : (
            t('player.parents.sendRequest')
          )}
        </button>
      </form>
    </div>
  );
};

export default SendRequestForm; 